export const HotelAwardsBlogPost = 'https://www.roomex.com/blog/roomex-launches-workforce-hotel-award';
